import React, { useState } from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { RiInstagramFill } from "react-icons/ri";
import { IoLogoLinkedin } from "react-icons/io5";
import { FaXTwitter } from "react-icons/fa6";
import { landing_status, social_media_links } from "../constants/Constants_Var";
import img1 from "./Assets/Images/Frame 20.webp";
import img2 from "./Assets/Images/Frame 21.webp";
import Subscribe from "../subscribe/Subscribe";
import Model from "../waitlistform/WaitListForm";

const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hover, setHover] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const redirect = (link) => window.open(link, "_blank");

  return (
    <>
      <Subscribe />

      <section className="lp-container">
        <div className="contact-sec">
          <div>
            <h3 style={{ color: "#32323280", fontWeight: "600" }}>
              How can we help?{" "}
              <span
                style={{
                  color: hover ? "#2a8ddf" : "#323232",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={openModal}
              >
                Contact us
              </span>
            </h3>
            <Model
              isOpen={isModalOpen}
              onClose={closeModal}
              name="inputwaitlist5"
              status={landing_status.contact}
            />
          </div>

          <div className="social-icon">
            <IoLogoLinkedin
              onClick={() => redirect(social_media_links.linkedin)}
              className="landing-social-icon-hover"
            />
            <RiInstagramFill
              onClick={() => redirect(social_media_links.instagram)}
              className="landing-social-icon-hover"
            />
            <FaXTwitter
              onClick={() => redirect(social_media_links.twitter)}
              className="landing-social-icon-hover"
            />
          </div>
        </div>
      </section>

      <footer className="footer-container">
        <div className="footer-section">
          <img
            src={img2}
            alt="NewslettrAI - email logo"
            className="side-img"
            style={{ marginTop: "100px" }}
          />
          <h1 className="footer-logo">NewslettrAI</h1>
          <img
            src={img1}
            alt="NewslettrAI - star logo"
            className="side-img"
            style={{ marginBottom: "100px" }}
          />
        </div>

        <div className="lp-container">
          <nav className="footer-nav">
            <p style={{ color: "#32323280" }}>© 2025 All rights reserved.</p>
            <div className="footer-span">
              <Link to="/privacy">
                <span className="landing-hover-text">Privacy Policy</span>
              </Link>
              <Link to="/faq">
                <span className="landing-hover-text">FAQ</span>
              </Link>
              <Link to="/term">
                <span className="landing-hover-text">Terms of Use</span>
              </Link>
            </div>
          </nav>
        </div>
      </footer>
    </>
  );
};

export default Footer;
